<script setup>
import { computed } from 'vue';

const props = defineProps({
  imageSource: {
    type: String,
    required: true,
  },
  icon: {
    type: Array,
    required: true,
  },
  iconBackgroundColor: {
    type: String,
    required: false,
    default: 'bg-yellow-300',
  },
  iconColor: {
    type: String,
    required: false,
    default: 'text-neutral-0',
  },
  size: {
    type: String,
    required: false,
    default: 'lg',
  },
});

const badgeSize = computed(() => {
  return props.size === 'lg' ? 'w-[74px] h-[74px]' : 'w-[32px] h-[32px]';
});

const iconSize = computed(() => {
  return props.size === 'lg' ? 'w-[24px] h-[24px]' : 'w-[18px] h-[18px]';
});
</script>
<template>
  <div class="relative">
    <img
      :src="imageSource"
      class="object-cover rounded-full mr-2 border-2 border-white"
      :class="badgeSize"
    />

    <div
      class="absolute shadow-smallBold flex items-center justify-center rounded-full border-white border-2 bg-yellow-300 bottom-[2px] right-[6px]"
      :class="iconSize"
    >
      <fa-icon :icon="icon" class="text-black text-xs" />
    </div>
  </div>
</template>
